/**
 * ============================================================================
 * ESCROWS PAGE - 100% Ready
 * ============================================================================
 * 
 * Page for listing all user escrows
 */

import React from 'react';
import { UserDashboardLayout } from '../components/user';
import EscrowDashboard from '../components/escrow/EscrowDashboard';

/**
 * Escrows Page Component
 * @returns {JSX.Element}
 */
const Escrows = () => {
  return (
    <UserDashboardLayout>
      <EscrowDashboard />
    </UserDashboardLayout>
  );
};

export default Escrows;
